export const createSoaFormConstants = {
    name: 'Name',
    soa_email: 'SOA Email',
    group_id: 'Group ID'
};
